import PropTypes from "prop-types";
import React from "react";

const TimeConstraints = ({showDesc, title}) => {
  return (
    <span className="TimeConstraints">
      <span
        className="erg-margin-right-5 text-warning"
        title={!showDesc ? title : ""}>
        <i className="fa fa-exclamation-circle" />
      </span>
      {showDesc ? <span className="icon-desc">{title}</span> : null}
    </span>
  );
};

TimeConstraints.propTypes = {
  showDesc: PropTypes.bool,
  title: PropTypes.string,
};

TimeConstraints.defaultProps = {
  title: "Has Time Constraints",
};

export default TimeConstraints;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/icons/TimeConstraints.js
 **/